import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Calendar, Heart, Camera, Ticket } from "lucide-react";

/** Mobile bottom tab bar — only renders on small screens.
 * 5 main functions: Home, Events, Match, AI Gallery, Tickets. */
export default function BottomNav() {
  const { pathname } = useLocation();
  const items = [
    { to: "/",            icon: Home,     label: "Home",    testid: "bn-home",    match: (p) => p === "/" },
    { to: "/#events-grid",icon: Calendar, label: "Events",  testid: "bn-events",  match: (p) => p === "/" && (typeof window !== "undefined" ? window.location.hash === "#events-grid" : false) },
    { to: "/clubvip",     icon: Heart,    label: "Match",   testid: "bn-match",   match: (p) => p.startsWith("/clubvip") },
    { to: "/ai-gallery",  icon: Camera,   label: "Gallery", testid: "bn-gallery", match: (p) => p.startsWith("/ai-gallery") },
    { to: "/profile",     icon: Ticket,   label: "Tickets", testid: "bn-tickets", match: (p) => p.startsWith("/profile") },
  ];
  return (
    <>
      <div style={{ height: 68 }} className="md:hidden" aria-hidden />
      <nav data-testid="bottom-nav" className="md:hidden fixed bottom-0 left-0 right-0 z-40" style={{
        background: "rgba(10,10,10,0.85)", backdropFilter: "blur(18px) saturate(140%)",
        WebkitBackdropFilter: "blur(18px) saturate(140%)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 -6px 30px rgba(0,0,0,0.6)",
      }}>
        <div className="grid grid-cols-5">
          {items.map((it) => {
            const active = it.match(pathname);
            return (
              <NavLink key={it.label} to={it.to} data-testid={it.testid} end={it.to === "/"}
                className={() => `flex flex-col items-center justify-center py-2.5 text-[10px] font-mono uppercase tracking-widest transition-colors ${active ? "text-lime" : "text-muted hover:text-white/80"}`}>
                <it.icon className={`w-5 h-5 mb-1 transition-transform ${active ? "scale-110" : ""}`} />
                {it.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </>
  );
}
